import { render, staticRenderFns } from "./PageSettingsPointsCategories.vue?vue&type=template&id=d3c6412a&"
import script from "./PageSettingsPointsCategories.vue?vue&type=script&lang=js&"
export * from "./PageSettingsPointsCategories.vue?vue&type=script&lang=js&"
import style0 from "./PageSettingsPointsCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports